import { initialListPaginationMeta } from "utils/helpers/pagination";

import { HydraulicWallForm, HydraulicWallState } from "../types";

export const initialHydraulicWallForm: HydraulicWallForm = {
  number: "",
  description: "",
};

export const initialHydraulicWallMeta = initialListPaginationMeta;

export const initialState: HydraulicWallState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialHydraulicWallMeta,
  error: null,
  isAddModalOpen: false,
  form: initialHydraulicWallForm,
};
